<div class="container" [class.checked]="radioControl.checked">
  <label class="card">
    <span class="card__general">
      <i
        class="card__general_icon icon"
        [ngClass]="[icon(), danger() ? 'danger' : '']"
      ></i>
      <span class="card__general-info general-info">
        <span class="general-info__name">{{ label() }}</span>
        @if (danger()) {
          <span class="general-info__warning">{{ danger() }}</span>
        }
      </span>
    </span>

    @if (description()) {
      <span class="card__description">{{ description() }}</span>
    }

    <input
      #radioControl
      type="radio"
      class="card__control"
      [name]="name()"
      [value]="radioValue()"
      [ngModel]="value()"
      (change)="onValueChange()"
      (blur)="onTouched()"
    />
  </label>

  @if (subitems().length > 0 && radioControl.checked) {
    <ul class="subitems-list">
      @for (subitem of subitems(); track $index) {
        <li
          class="subitems-list__item subitem"
          [class.checked]="subitemRadioControl.checked"
        >
          <label class="subitem__label">
            <span class="subitem__label-text">{{ subitem.label }}</span>

            <input
              #subitemRadioControl
              type="radio"
              class="subitem__control"
              [name]="subitemName"
              [value]="subitem.value"
              [ngModel]="subitemValue()"
              (change)="onSubitemValueChange(subitem.value)"
              (blur)="onTouched()"
            />
          </label>
        </li>
      }
    </ul>
  }
</div>
